import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";
import evidencijeImg from "../../../../picture/evidencije-obrasci.png";

const obrazci = [
  "ПОВЕЋАНИ РИЗИК И ЛЕКАРСКИ ПРЕГЛЕДИ",
  "ПОВРЕДЕ НА РАДУ",
  "ПРОФЕСИОНАЛНЕ БОЛЕСТИ",
  "ИЗЛОЖЕНОСТ БИОЛОШКИМ ШТЕТНОСТИМА",
  "ИЗЛОЖЕНОСТ КАНЦЕРОГЕНИМА И ДР.",
  "ОБУКА ЗА БЗР И КОРИШЋЕЊЕ ЛЗО",
  "КОНТРОЛНЕ ЛИСТЕ",
  "ПРЕГЛЕДИ И ПРОВЕРЕ ОПРЕМЕ ЗА РАД",
  "ПРЕГЛЕДИ/ИСПИТИВАЊА ЕЛЕКТРОИНСТАЛАЦИЈА",
  "ИСТИПИТВАЊА УСЛОВА РАДНЕ СРЕДИНЕ",
  "ИЗДАТА ЛЗО"
];

function ShowBarEvidencije() {
  const { selectedEvidencija, setSelectedEvidencija } = useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedEvidencija !== index + 1) {
      setSelectedEvidencija(index + 1);
    } else {
      setSelectedEvidencija(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px"
        }}
      >
        <img src={evidencijeImg} style={{ width: "40%" }} />
      </div>
      <div style={{ height: "500px", overflowY: "auto" }}>
        {obrazci.map((obrazac, i) => (
          <div onClick={() => handleClickObrazac(i)}>
            <Button
              active={selectedEvidencija === i + 1}
              style={{
                padding: "7px",
                fontWeight: "bold",
                textAlign: "left",
                minHeight: "64px",
                display: "block",
                fontSize: "16px"
              }}
            >
              {i + 1}. {obrazac}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShowBarEvidencije;
